// overload jQuery ajax method for dealing with checkAlive return
window.jQueryAjax = $.ajax;

$.ajax = function (...args) {
    // Store success callback
    var ajaxSuccess = args[0].success;

    if (typeof ajaxSuccess == 'function') {

        // Add treatment before success callback
        args[0].success = function (...data) {
            // Check data return - if user is logout
            let dataToParse = data[0];
            if (typeof dataToParse == 'string' && dataToParse.length > 0 && !/^</i.test(dataToParse)) {
                let json = JSON.parse(dataToParse);
                if (json.status == 'logout') {
                    CheckAlive.performCallback(json);
                    return;
                }
            }
            // Execute original success callback
            return ajaxSuccess(...data);
        }

    }

    return jQueryAjax(args[0]);
};